import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {
  Badge,
  Button,
  ButtonGroup,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton
} from '@mui/material';
import FileMap from "../item-map/FileMap";
import FolderSelector from '../../folders/FolderSelector';
import {
  DateIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  FolderIcon,
  LocationIcon,
  MoveIcon,
  OpenIcon,
  RotateIcon,
  ShareIcon,
  SpacecastIcon,
  TagIcon
} from '../../../../../helpers/Icons'
import UploadPreview from './UploadPreview';
import MindfileItemForm from "../form/MindfileItemForm";
import ItemShareForm from "./ItemShareForm";
import {rotateImage} from "../../../../../api/fileExplorerApi";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";
import UploadThumbnail from "./UploadThumbnail";
import {openLinkStyle} from "../../../../util/data-table/list-view/DataListView";
import ItemTypeIcon from "../../../../../helpers/ItemTypeIcon";
import {
  formatByteSize,
  formatDate,
  formatDateTime,
  formatLocation,
  formatStyles
} from "../../../../../helpers/FormatUtils";
import {ExpandLess} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import MindfileAvatarTopBar from "./MindfileIAvatar";
import {getValid, testValid} from "../form/ItemFormDialog";
import {API_ROOT} from "../../../../../baseUrls";
import SurveyView from "../../surveys/SurveyView";
import {answerAllSurvey, answerSurvey, loadSurvey, resetSurvey} from "../../../../../state/actions/surveyActions";


const styles = {
  ...formatStyles,
  icons:{
    verticalAlign: 'middle',
    display:'flex',
    flexDirection:'row',
    flexWrap:'nowrap',
  },
  pendingButton:{
    // height:'40px'
  },
  pendingIcon: {
    color: '#ffb506',
  },
  descriptionCollapse: {
    // display: '-webkit-box',
    // '-webkit-line-clamp': 11,
    // '-webkit-box-orient': 'vertical',
    overflow: 'auto',
    maxHeight: 'calc(1.25em * 14.75)',
    paddingRight:'0.5rem',
    whiteSpace:'pre-wrap',
  },
  descriptionFull: {
    whiteSpace:'pre-wrap',
  },
  noDescription:{
    fontStyle:'italic',
    opacity:0.5,
    fontSize:'0.85rem'
  },
  tagCellAction: {
    // whiteSpace:'nowrap',
    textDecoration:'underline',
    cursor:'pointer',
    '&:hover':{
      opacity:0.65
    }
  },
  tagListInner: {
    maxHeight:'100%',
    display: 'flex',
    position:'relative',
    // padding:'0.25rem 0',
    // lineHeight:'1rem',
    flexWrap: 'wrap',
    gap: '0.1em',
    '& div:nth-child(2)':{
      // marginLeft:'2.25em'
    }
  },
  tagListItem: {
    display:'inline-block',
    // marginRight: '6px',
    // fontSize:'0.85em',
    // whiteSpace:'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis'
  },
  tagListActionItem: {
    display:'inline-block',
    marginRight: '6px',
    // fontSize:'0.85em',
    // whiteSpace:'nowrap',
    textDecoration:'underline',
    overflow:'hidden',
    textOverflow:'ellipsis',
    cursor:'pointer',
    '&:hover':{
      opacity:0.65
    }
  },
  toolbar: {
    flexWrap:'wrap',
    margin: '1px 0 0 1px',
    '& > button':{
      margin: '-1px 0 0 -1px',
      borderColor: '#c4c4c4'
    },
    '& > button:not(:last-child)':{
      borderColor: '#c4c4c4'
    }
  },
  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225rem',
    height: '34px',
    color: 'rgba(0, 0, 0, 0.87)',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    '& span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  toolbarButtonOpen: {
    padding: '5.1px 10.2px',
    color: '#267ea6',
    borderColor: '#267ea6',
    backgroundColor: '#f6f6f6',
    fontSize: '0.7225rem',
    height: '34px',
    '& span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  collapseContent: {
    display: 'flex',
    margin: '0.5rem 0.5rem 0',
    padding: '0',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    overflow: 'visible',
    position: 'relative'
  },
  collapseLabel:{
    flexShrink: 0,
    fontSize: '0.85rem',
    padding: '0 4px',
    marginTop:'-12px',
    position: 'absolute',
    left: '1em',
    backgroundColor: '#ffffff',
    '&> button':{
      // textTransform: 'none',
      padding: '0px 4px',
      fontWeight: 500,
      fontSize: '0.85em',
      color: 'rgba(0, 0, 0, 0.87)'
    }
  },
  root:{
    display:'flex',
    flexDirection:'column',
    gap: '0.75rem',
    // paddingBottom:'1rem'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem 1rem',
    margin: '0.5rem 0.5rem 0',
  },
  title:{
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '0.25rem 1rem',
    justifyContent:'space-between',
  },
  titleRight:{
    display: 'inline-flex',
    flexDirection: 'row',
    gap: '0.25rem 1.5rem',
    flexWrap: 'wrap',
    flexBasis: '1em',
    flexGrow: 1,
    fontSize: '0.85em',
    maxHeight:'3em',
    // marginTop:'0.25rem',
  },
  name:{
    fontSize: '1.25em',
    flexGrow: 10,
    flexBasis: '35rem',
    fontWeight: 400,
    marginRight: 'auto',
    display:'inline-flex',
    wordBreak:'break-all',
    paddingTop: '4px',
    // minHeight: '46px',
    '& > svg':{
      color: '#005985',
      width: '1.5rem',
      maxHeight: '34px',
      height: '100%',
      fontSize: 'inherit',
      margin: '0em 0.35em 0 0',
      alignSelf: 'first baseline',
      paddingTop: '0px',
    },
    // alignItems:'center',
  },
  nameLink:{
    ...openLinkStyle(''),
    position:'relative',
    textDecoration:'underline 1px',
    display: 'inline',
    paddingBottom: '4px',
  },
  checkbox:{
    // alignItems:'start',
    padding: '5px',
    marginLeft: '-5px',
    // height: '1rem',
    // verticalAlign: 'text-top',
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    // gap: '1.5rem 1rem',
    position:'relative',
    justifyContent: 'center',
    marginRight:'0.5rem'
  },
  content:{
    flexBasis:'20em',
    flexGrow:100,
    display: 'flex',
    flexDirection: 'column',
    // height:'100%',
    gap:'0.5em',
    justifyContent:'space-between',
  },
  description:{
    fontWeight: 300,
    margin: '0 0 0.5rem 0.5rem',
  },
  previewWrapper:{
    margin: '0 0 0.5rem 0.5rem',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '0.5rem 1rem'
  },
  rowReverse: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap-reverse',
    gap: '0.5rem 1rem',
    flexGrow: 1,
    justifyContent: 'space-between',
    '& > *': {
      // minWidth:'calc(50% - 0.5em)',
      maxWidth:'100%',
      flexGrow: 1,
    }
  },
  rowSpaced: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '0.35rem 1rem',
    flexGrow: 1,
    // '& > div:last-child': {
    //   margin:'0 auto'
    // },
    '& > *': {
      flexGrow: 1,
      flexShrink: 1
    },
    '& > *:first-child': {
      // width:'calc(50% - 0.5em)',
      // minWidth:'calc(50% - 0.5em)',
      maxWidth:'100%',
      flexGrow: 1,
      flexShrink: 0
    },
  },
  customFields: {
    marginTop: "auto",
    marginLeft: "0.5rem",
  },
  fields: {
    // paddingRight: "0.5rem",
    flex: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "0.35rem 1rem",
    '& > div': {
      flex: 1,
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    // flexWrap: 'wrap',
    gap: '0.25rem 0.75rem',
    margin:'0',
    marginRight:'-0.5rem',
    backgroundColor:'#00000004',
    padding: '0.25rem 0.5rem',
    borderTop: '1px solid rgba(0, 0, 0, 0.22)',
  },
  field: {
    fontWeight: 300,
    fontSize:'0.85em',
    overflow:'hidden',
    textOverflow:'ellipsis',
    // textAlign:'center'
  },
  label: {
    fontSize:'0.7225rem',
    fontWeight: 600,
    color: '#003e58',
    textTransform: 'uppercase',
    lineHeight: '1.35em',
  },
  folder: {
    display:'inline-flex',
    flexDirection:'row',
    flexWrap:'nowrap',
    whiteSpace:'nowrap',
    gap:'0.5em',
    '& > svg':{
      fontSize: '20px',
      width:'0.85em',
      height:'0.85em',
      alignSelf:'top',
      color: "#003e58"
    }
  },
  folderLink: {
    whiteSpace:'nowrap',
    textDecoration:'underline',
    cursor:'pointer',
    fontWeight: 500,
    '&:hover':{
      opacity:0.65,
    }
  },
  folderNoLink: {
    whiteSpace:'nowrap',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  extension:{
    textTransform:'uppercase',
  },

  mapControls: {
    display: 'flex',
    marginTop: '1em',
    padding: '0',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    overflow: 'visible',
    position: 'relative'
  },
  mapLabel: {
    flexShrink: 0,
    fontSize: '0.85rem',
    padding: '0 4px',
    marginTop:'-12px',
    position: 'absolute',
    '&> button':{
      // textTransform: 'none',
      backgroundColor: '#ffffff',
      padding: '0px 4px',
      fontWeight: 500,
      fontSize: '0.85em',
      zIndex: 10,
      '&:hover':{
        backgroundColor: '#f5f5f5',
      }
    },
    marginLeft: '1em'
  },
};

function formatArray(id, arr, textMapping, idMapping, action, classes){
  const items = (arr || []).filter(item => !!item && typeof(item) !== "string").map(item => ({text: textMapping(item), id: idMapping ? idMapping(item) : null}));
  return (<div id={id} className={classes.tagListInner}>
    {action ? items.map((item) =>
        <div key={item.id} className={classes.tagListActionItem} onClick={(e) => {
          if(e){
            e.preventDefault();
            e.stopPropagation();
          }
          action(item.id);
        }}>
          {item.text}
        </div>
      )
      : items.map((item, index) =>
        <div key={item.id} className={classes.tagListItem}>
          {item.text}
        </div>
      )}
  </div>);
};

const formatItem = (id, item, textMapping, idMapping, action, classes) => {
  const text = textMapping(item);
  const itemId = idMapping ? idMapping(item) : null;

  return action && !!id ?
    <span id={id} className={classes.tagCellAction} onClick={(e) => {
      if(e){
        e.preventDefault();
        e.stopPropagation();
      }
      action(itemId);
    }}>
        {text}
      </span>
    : <span id={id}>{text}</span>;
}

const formatText = (id, text) => {
  return <span id={id}>{text}</span>;
}

export const show_url = (item, representaion) => {
  return `${API_ROOT}/mindfiles/${item.mindfile_id}/show/${item.item_data_id}/${item.url_show_hash}/${representaion}?ts=${item.url_ts}`
};

function MindfileItemView(props) {
  const { mindfileUserLevel, item, mindfileDisplay, handleClose, setItem, columnMap, isEdit, setEdit,
          folderList, addFolder, addFilterSelectByName, mindfileFilterValues, initialDisplayType, collapsed,
          canSelect, isSelected, onSelectItem, openDataView,
          showToolbar, showStatusIcon, getMindfileItem, itemChangeCallback,
          saveItems, moveItem, removeItem,
          mindfile, loadSurvey, resetSurvey, answerSurvey, answerAllSurvey, classes } = props;
  const history = useHistory();

  const [mapOpen, setMapOpen] = useState(false);
  const [editItem, setEditItem] = useState({...item});
  const [shareOpen, setShareOpen] = useState(false);

  const [selectedFolder, setSelectedFolder] = useState(!folderList ? null : [...folderList.filter(f => f.id !== item.folder.id), item.folder][0]);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const [editOpenState, setEditOpenState] = useState(false);
  const [editOpen, setEditOpen] = setEdit ? [isEdit, setEdit] : [editOpenState, setEditOpenState];
  const [moveOpen, setMoveOpen] = useState(false);
  const [displayType, setDisplayType] = useState(initialDisplayType || "thumbnail");

  useEffect(() => {
      const prev = editItem;
      const newItem = item;
      if(!prev || !newItem || prev.id !== newItem.id){
        return;
      }
      if(newItem.url_ts !== prev.url_ts || newItem.item_data.conversion !== prev.item_data.conversion){
        const url = `/mindfiles/${prev.mindfile_id}/show/${prev.item_data_id}/${prev.url_show_hash}/thumbnail?ts=${newItem.url_ts}`
        if(newItem.item_data.conversion !== prev.item_data.conversion) {
          setEditItem({
            ...prev,
            url_ts: newItem.url_ts,
            updated_at: newItem.updated_at,
            item_data: {...prev.item_data, conversion: newItem.item_data.conversion},
            thumbnail_url: url
          });
        } else {
          setEditItem({...newItem});
        }
      }
    },
    // eslint-disable-next-line
    [item.url_ts]
  );

  const rotateImage = (item) => {
    props.rotateImage(item.mindfile_id, item.item_data_id, (item) => {
      !!setItem && setItem(item);
    })
  };

  const statusIcon = () => {
    return item.status === 'pending' ? (
      // todo: icon small
        <IconButton id="itemPendingIcon" size="small" className={classes.pendingButton} onClick={setEditOpen.bind(this, true)}>
          <TagIcon style={{color: '#ffb506'}} />
        </IconButton>
      ) : null;
  }

  const renderButton = (button, classes, props={}) =>
    <Button variant="outlined"
      {...props}
      id={button.id}
      key={button.label}
      disabled={button.disabled}
      className={button.open ? classes.toolbarButtonOpen : classes.toolbarButton}
      onClick={button.action}
      startIcon={button.startIcon}
    >
      {button.label}
    </Button>;

  const toolbar = [
      { id: 'itemDownload',
        label: 'Download',
        startIcon: <DownloadIcon />,
        hidden: mindfileUserLevel > 1 || item.item_data_type !== 'Upload' || item.status === 'pending',
        action: () => {window.location = show_url(item, 'download')}
      },
      { id: 'itemShare',
        label: <>
          <Badge id="shareActive" invisible={!item.share_hash} variant="dot" color="secondary" overlap="rectangular">
            Share
          </Badge></>,
        startIcon: <ShareIcon />,
        open: shareOpen,
        hidden: mindfileUserLevel > 1 || item.status === 'pending',
        action: () => setShareOpen(!shareOpen)
      },
      { id: 'itemTag',
        label: 'Tag',
        startIcon: <TagIcon />,
        open: editOpen,
        hidden:item.status !== 'pending',
        action: () => setEditOpen(!editOpen)
      },
      { id: 'itemEdit',
        label: 'Edit',
        startIcon: <EditIcon />,
        open: editOpen,
        hidden:item.status === 'pending',
        action: () => setEditOpen(!editOpen)
      },
      { id: 'itemMove',
        label: 'Move',
        startIcon: <MoveIcon />,
        open: moveOpen,
        action: setMoveOpen.bind(this, true)
      },
      { id: 'itemRotate',
        label: 'Rotate',
        startIcon: <RotateIcon />,
        hidden: item.item_data_type !== 'Upload' || item.item_data.type !== 'image',
        disabled: item.item_data.conversion !== true,
        action: () => {rotateImage(item)}
      },
      { id: 'itemDelete',
        label: 'Delete',
        startIcon: <DeleteIcon />,
        open: deleteOpen,
        action: setDeleteOpen.bind(this, true),
        hidden: mindfileUserLevel > 1
      },
    ];

  const mapButtonDef = {
      id: 'mapOpen',
      label: 'Map',
      startIcon: <LocationIcon />,
      action: () => setMapOpen(!mapOpen),
      open: mapOpen
    };


  const openSpacecast = () => {
    if(props.viewItem === null || props.viewItem.id !== item.id || props.viewItem.url_ts < item.url_ts || !props.viewItem.spacecasts){
      getMindfileItem(item.mindfile_id, item.id, false, (data) => {
        history.push(`/explore/spacecast3d`)
      })
    }else{
      history.push(`/explore/spacecast3d`)
    }
  }
  const spaceCastButton = {
      id: 'spacecastOpen',
      label: 'Spacecast',
      startIcon: <SpacecastIcon />,
      action: () => openSpacecast()
    };

  const columnAction = (key) => {
    const action = !!columnMap ? columnMap[key]?.action || null : null;
    if(typeof(action) === "function"){
      return (itemId) => {
        action(itemId);
        if(handleClose){
          handleClose();
        }
      }
    }
    return action;
  };
  const columnHidden = (key) => {
    return !!columnMap ? columnMap[key]?.viewHidden || false : false;
  };

  const tagFields = !columnMap ? [] : Object.values(columnMap).filter(col => !!col.viewText && col.viewPlacement === "tags" && (!col.viewEnabled || col.viewEnabled(item)))

  const isUpload = item.item_data_type === "Upload";
  const [validations, setValidations] = useState({
    name: false,
    description: false,
    date: false,
    emotion: false,
    beme: false,
  });

  const validateFields = {
    name: () => !editItem.name,
    description: () => !editItem.description && item.item_data_type !== "SurveyAttempt",
    date: () => !editItem.date,
    emotion: () => isUpload && !editItem.emotion,
    beme: () => isUpload && !editItem.beme,
  };

  const isValid =  testValid(validations);
  const curValid = testValid(getValid(validateFields))
  const validate = () => {
    const v = getValid(validateFields);
    setValidations(v);
    return testValid(v);
  };

  return (
    <>
      <MindfileAvatarTopBar
        item={item}
        handleClose={handleClose}
        mindfileDisplay={mindfileDisplay}
      />
      <div className={classes.root}>
        <div className={classes.header}>
          <div className={classes.title}>
            <div className={classes.name}>
              {canSelect && showToolbar ? <span id="selectedCell"><Checkbox id="itemSelect" className={classes.checkbox} checked={isSelected} onClick={onSelectItem} /></span> : null}
              {showStatusIcon && showToolbar ? statusIcon() : null}
              <ItemTypeIcon id="typeCell" item={item}/>
              {!!openDataView ?
                <div id="nameCell" style={{alignSelf:"center"}} className={classes.nameLink} onClick={() => openDataView(item.id)}>
                  {item.name}
                  <OpenIcon fontSize="small" />
                </div>
                : <span id="nameCell" style={{alignSelf:"center", paddingBottom:'2px'}}>{item.name}</span>
              }
            </div>
            <div className={classes.titleRight}>
              <div className={classes.folder}>
                <DateIcon size="small"/>
                {formatDate("dateCell", !!item.date ? item.date : item.created_at, classes)}
              </div>
              {columnHidden("folderName") ? null :
                <div className={classes.folder}>
                  <FolderIcon size="small"/>
                  {columnAction("folderName") ?
                    <div id="folderCell" className={classes.folderLink} onClick={(e) => {
                      if(e){
                        e.preventDefault();
                        e.stopPropagation();
                      }
                      history.push(`/explore/folder/${item.folder_id}`);
                    }}>
                      {item.folder.name}
                    </div>
                    : <div id="folderCell" className={classes.folderNoLink}>
                      {item.folder.name}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          {showToolbar ?
            <ButtonGroup variant="outlined" className={classes.toolbar}>
              {toolbar.filter(tool => !tool.hidden).map(tool => renderButton(tool, classes))}
            </ButtonGroup>
            : null
          }
        </div>
        <Collapse in={shareOpen} timeout="auto" unmountOnExit>
          <FormControl id="itemShareSection" className={classes.collapseContent}>
            <FormLabel className={classes.collapseLabel} component="div">
              <Button id="shareCloseLabel" onClick={() => setShareOpen(!shareOpen)}>
                Share<ExpandLess size="small" variant="outlined" style={{fontSize: '1rem'}} />
              </Button>
            </FormLabel>
            <ItemShareForm
              viewItem={item}
              closeShare={setShareOpen.bind(this, false)}
            />
          </FormControl>
        </Collapse>
        {!editOpen || !showToolbar ? <>
          <div className={classes.body}>
            {item.item_data_type === 'SurveyAttempt' ?
              <SurveyView
                folderId={item.folder_id}
                attemptId={item.item_data_id}
                surveyAttempt={item.item_data}
                loadSurvey={loadSurvey.bind(this, mindfile.id, item.item_data_id)}
                resetSurvey={resetSurvey.bind(this, mindfile.id, item.item_data_id)}
                answerSurvey={answerSurvey.bind(this, mindfile.id, item.item_data_id)}
                answerAllSurvey={answerAllSurvey.bind(this, mindfile.id, item.item_data_id)}
                itemChangeCallback={itemChangeCallback}
                openDataView={openDataView}
                filterName={addFilterSelectByName.bind(this, 'Assessment')}
              />
              : item.item_data_type !== 'Upload'? null
              : displayType !== 'preview' ?
                <UploadThumbnail id="itemThumbnail" className={classes.previewWrapper} item={item} size="lg" onClick={() => setDisplayType("preview")} />
              : <UploadPreview id="itemPreview"
                  className={classes.previewWrapper}
                  item={item}
                  handlePreviewClose={() => setDisplayType("thumbnail")}
                  downloadFile={() => {window.location = show_url(item, 'download')}}
                  mindfileUserLevel={mindfileUserLevel}
                />
            }
            <div className={classes.content}>
              <div className={classes.description}>
                <div className={classes.label}>
                  Description
                </div>
                <div id="descriptionCell" className={!!collapsed ? classes.descriptionCollapse : classes.descriptionFull}>
                  {item.description}
                </div>
                { !item.description ? <span className={classes.noDescription}>No Description</span> : null }
              </div>

              {tagFields.length === 0 ? null :
                <div id={"customFields"} className={`${classes.rowSpaced} ${classes.fields} ${classes.customFields}`}>
                  {tagFields.map(col =>
                    <div key={col.key} className={classes.field}>
                      <div className={classes.label}>
                        {col.header.label || col.header.shortLabel || col.header[0].label || col.header[0].shortLabel}
                      </div>
                      {formatItem(col.key, item, i => col.viewText(i, classes), i => i, col.action, classes)}
                    </div>
                  )}
                </div>
              }
              <div className={classes.column}>
                {columnHidden("keywords") && columnHidden("people") ? null :
                  <div className={`${classes.rowSpaced} ${classes.fields}`}>
                    {columnHidden("keywords") ? null :
                      <div className={classes.field}>
                        <div className={classes.label}>
                          Keywords (<span id="itemKeywordsCount">{item.keywords.length}</span>)
                        </div>
                        {formatArray("keywordsCell", item.keywords, k => k.text, k => k.id, columnAction('keywords'), classes)}
                      </div>
                    }
                    {columnHidden("people") ? null :
                      <div className={classes.field}>
                        <div className={classes.label}>
                          People (<span id="itemPeopleCount">{item.people.length}</span>)
                        </div>
                        {formatArray("peopleCell", item.people, p => p.name, p => p.id, columnAction('people'), classes)}
                      </div>
                    }
                  </div>
                }

                <div className={classes.rowSpaced}>
                  {columnHidden("created") ? null :
                    <div className={classes.field}>
                      <div className={classes.label}>
                        Created
                      </div>
                      {formatDateTime("createdCell", item.created_at, classes)}
                    </div>
                  }
                  {columnHidden("updated") ? null :
                    <div className={classes.field}>
                      <div className= {classes.label}>
                        Updated
                      </div>
                      {formatDateTime("updatedCell", item.updated_at, classes)}
                    </div>
                  }
                  {columnHidden("emotion") ? null :
                    <div className={classes.field}>
                      <div className={classes.label}>
                        Emotion
                      </div>
                      {formatItem("emotionCell", item, i => i.emotion, i => i.emotion, columnAction('emotion'), classes)}
                    </div>
                  }
                  {columnHidden("beme") ? null :
                    <div className={classes.field}>
                      <div className={classes.label}>
                        Beme
                      </div>
                      {formatItem("bemeCell", item, i => i.beme, i => i.beme, columnAction('beme'), classes)}
                    </div>
                  }
                  {item.item_data_type === 'Upload' ?
                    <>
                      {columnHidden("extension") ? null :
                        <div className={`${classes.field} ${classes.extension}`}>
                          <div className={classes.label}>
                            Ext
                          </div>
                          {formatText("extensionCell", item.item_data.extension)}
                        </div>
                      }
                      {columnHidden("size") ? null :
                        <div className={classes.field}>
                          <div className={classes.label}>
                            Size
                          </div>
                          {formatText("sizeCell", formatByteSize(item.item_data.size, classes))}
                        </div>
                      }
                      {columnHidden("source") ? null :
                        <div className={classes.field}>
                          <div className={classes.label}>
                            Source
                          </div>
                          {formatText("sourceCell", item.item_data.source)}
                        </div>
                      }
                    </>
                    : null
                  }
                  {columnHidden("location") ? null :
                    <div className={classes.row}>
                      <div className={classes.field}>
                        <div className={classes.label}>
                          Location
                        </div>
                        {formatLocation("locationCell", item.location, classes)}
                      </div>
                      {item.location && item.location.latitude ? renderButton(mapButtonDef, classes) : null }
                    </div>
                  }
                  {columnHidden("spacecast") || !item.spacecast_upload ? null :
                    <div className={classes.field}>
                      {renderButton(spaceCastButton, classes)}
                    </div>
                  }
                </div>
                <Collapse key='map' in={mapOpen} timeout="auto" unmountOnExit>
                  <FormControl id="itemMapSection" className={classes.mapControls}>
                    <FormLabel className={classes.mapLabel} component="div">
                      <Button id="mapCloseLabel" onClick={() => setMapOpen(!mapOpen)}>Map <ExpandLess size="small" variant="outlined" style={{fontSize: '1rem'}} /></Button>
                    </FormLabel>
                    <FileMap
                      isDraggable={false}
                      location={item.location}
                    />
                  </FormControl>
                </Collapse>
              </div>
            </div>
          </div>
        </>
        : <div id="itemEditSection">
            <div className={classes.body} style={{marginLeft:'0.5rem'}}>
              <MindfileItemForm
                mindfileUserLevel={mindfileUserLevel}
                item={editItem}
                itemType={item.item_data_type}
                handleItemChange={setEditItem}
                keywordsList={mindfileFilterValues.keywords}
                peopleList={mindfileFilterValues.people}
                folderList={folderList}
                addFolder={addFolder}
                validations={validations}
                errors={(isValid || curValid) ? null : Object.keys(validations).filter(key => validateFields[key]())}
              />
            </div>
            <DialogActions style={{position:'sticky', bottom:0, backgroundColor: '#fffc', zIndex: 10}}>
              <Button id="itemEditSave" onClick={() => {
                if(validate()) {
                  saveItems([editItem]);
                  setEditOpen(false);
                }
              }} variant="contained" color="primary">
                Save
              </Button>
              <Button id="itemEditCancel" onClick={setEditOpen.bind(this, false)} variant="contained" color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </div>
        }
        {moveOpen ?
          <Dialog
            id="itemMoveSection"
            onClose={() => {setMoveOpen(false)}}
            open={moveOpen}
          >
            <DialogTitle>
              <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
                Move {item.name}
                <IconButton
                  onClick={() => {
                    setMoveOpen(false);
                    setSelectedFolder(null);
                  }}
                  style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{paddingBottom: '8px'}}>
              <DialogContentText style={{marginBottom: '12px'}}>
                Move {item.name} to another folder.
              </DialogContentText>
              <div style={{width: '25em'}}>
                <FolderSelector
                  id="itemMoveFolder"
                  label="Folder"
                  selectedFolder={selectedFolder}
                  folderList={folderList}
                  addFolder={addFolder}
                  handleFolderSelect={(newVal) => setSelectedFolder(newVal)}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                id="itemMoveConfirm"
                variant="contained"
                color="primary"
                onClick={() => {
                  moveItem(selectedFolder.id);
                  setMoveOpen(false);
                  setSelectedFolder(null);
                }}
              >
                Move
              </Button>
              <Button
                id="itemMoveCancel"
                variant="contained"
                color="secondary"
                onClick={() => {
                  setMoveOpen(false);
                  setSelectedFolder(null);
                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          : null
        }
        { mindfileUserLevel <= 1 && deleteOpen ?
          <Dialog
            id="itemDeleteSection"
            onClose={() => {setDeleteOpen(false)}}
            open={deleteOpen}
          >
            <DialogTitle>
              <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
                Delete {item.name}
                <IconButton onClick={() => {setDeleteOpen(false)}} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to permanently delete {item.name}? This cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                id="itemDeleteConfirm"
                variant="contained"
                color="primary"
                onClick={() => {
                  removeItem();
                  setDeleteOpen(false);
                }}
              >
                Delete
              </Button>
              <Button
                id="itemDeleteCancel"
                variant="contained"
                color="secondary"
                onClick={() => {setDeleteOpen(false)}}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          : null
        }
      </div>
    </>
  );
}


const mapStateToProps = state => {
  return {
    // user: state.auth,
    mindfile: state.mindfile,
    viewItem: state.viewItem
  };
}

const mapDispatchToProps = {
  rotateImage,
  loadSurvey,
  resetSurvey,
  answerSurvey,
  answerAllSurvey,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MindfileItemView));
